import { render, staticRenderFns } from "./SecretSidebar.vue?vue&type=template&id=c25ad34c&scoped=true"
import script from "./SecretSidebar.vue?vue&type=script&lang=js"
export * from "./SecretSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25ad34c",
  null
  
)

export default component.exports